import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import type { ApiTypes } from '@hyundai/ng-common-lib';
import { FootnotesPipe, FormatPricePipe, RouterLinkDirective } from '@hyundai/ng-common-lib';
import { DealerCampaignContentModuleType } from '@hyundai/shared-lib';
import {
    M030C150TeaserListComponent,
    M040C020TeaserAllrounderComponent,
    M060C020VehicleLeasingExampleComponent,
} from '@hyundai/ui';

@Component({
    selector: 'app-dealer-campaign-modules',
    standalone: true,
    imports: [
        M030C150TeaserListComponent,
        M060C020VehicleLeasingExampleComponent,
        M040C020TeaserAllrounderComponent,
        RouterLinkDirective,
        FootnotesPipe,
        FormatPricePipe,
    ],
    templateUrl: './dealer-campaign-modules.component.html',
    styleUrl: './dealer-campaign-modules.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealerCampaignModulesComponent {
    contentModules = input.required<ApiTypes.DealerCampaignDetail['contentModules']>();

    DealerCampaignContentModuleType = DealerCampaignContentModuleType;
}
